import { Component, AfterViewInit, ElementRef, Input, OnInit, OnChanges, ViewChild, SimpleChanges } from '@angular/core';

import { ApiError, BaseFilterCollapse, BaseFilterCollapseService, MessageService } from '../../../core';
import { CidadeFilter } from './cidade-filter';
import { Estado, EstadoCrudHttpService } from '../../estado';
import { cidadeClassificacoes } from '../classificacao-abc';
import { RegiaoGeograficaIntermediaria, RegiaoGeograficaIntermediariaFilter, RegiaoGeograficaIntermediariaCrudHttpService } from '../../regiao-geografica/intermediaria';
import { RegiaoGeograficaImediata, RegiaoGeograficaImediataFilter, RegiaoGeograficaImediataCrudHttpService } from '../../regiao-geografica/imediata';

@Component({
    selector: 'sgt-cidade-filter-collapse',
    templateUrl: './cidade-filter-collapse.component.html'
})
export class CidadeFilterCollapseComponent implements BaseFilterCollapse, OnInit, OnChanges, AfterViewInit {
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';
    isFilterDirty = false;


    @Input() filter: CidadeFilter;
    estados: Estado[] = [];
    regioesIntermediarias: RegiaoGeograficaIntermediaria[] = [];
    regioesImediatas: RegiaoGeograficaImediata[] = [];
    classificacoes = cidadeClassificacoes;

    // Valores padrões
    @Input() situacao: number;

    constructor(private messageService: MessageService,
                private baseFilterCollapseService: BaseFilterCollapseService,
                private estadoCrudHttpService: EstadoCrudHttpService,
                private regiaoGeograficaIntermediariaCrudHttpService: RegiaoGeograficaIntermediariaCrudHttpService,
                private regiaoGeograficaImediataCrudHttpService: RegiaoGeograficaImediataCrudHttpService) { }

    ngOnInit() {
        this.searchEstados();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    ngAfterViewInit() {
      if (!this.isCollapsedInDefault) {
        jQuery(this.filterCollapse.nativeElement).css('display', 'none');
      }
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Limpa o filtro */
    clear() {
        this.baseFilterCollapseService.clear(this);
        this.clearEstado();
    }

    /** Pesquisa todos os estados */
    private searchEstados() {
        this.estadoCrudHttpService.search()
            .subscribe(
                entities => {
                    this.estados = entities;
                    if (this.filter.idEstado) {
                        this.searchRegioesIntermediarias();
                    }
                },
                (error: ApiError) => this.messageService.error(error.message,  'Erro ao pesquisar os estados para o filtro da cidade', error)
            );
    }

    /** Limpa os dados do estado */
    private clearEstado() {
        this.filter.idEstado = null;
        this.clearRegiaoIntermediaria();
    }

    /** Ao alterar o estado */
    onChangeEstado(idEstado: number) {
        this.clearRegiaoIntermediaria();

        if (idEstado) {
            this.filter.idEstado = idEstado;
            this.searchRegioesIntermediarias();
        } else {
            this.clearEstado();
        }

        this.isFilterDirty = true;
    }

    /** Pesquisa as regiões geográficas intermediárias do estado selecionado */
    private searchRegioesIntermediarias() {
        this.regioesIntermediarias = [];
        const filterRegiaoIntermediaria = new RegiaoGeograficaIntermediariaFilter();
        filterRegiaoIntermediaria.idEstado = this.filter.idEstado;
        this.regiaoGeograficaIntermediariaCrudHttpService.searchWithFilter(filterRegiaoIntermediaria)
            .subscribe(
                entities => {
                    this.regioesIntermediarias = entities;
                    if (this.filter.idRegiaoGeograficaIntermediaria) {
                        this.searchRegioesImediatas();
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as regiões intermediárias para o filtro da cidade', error)
            );
    }

    /** Limpa os dados da região geográfica intermediária */
    private clearRegiaoIntermediaria() {
        this.filter.idRegiaoGeograficaIntermediaria = null;
        this.regioesIntermediarias = [];
        this.clearRegiaoImediata();
    }

    /** Ao alterar a região geográfica intermediária */
    onChangeRegiaoIntermediaria(idRegiaoGeograficaIntermediaria: number) {
        this.clearRegiaoImediata();

        if (idRegiaoGeograficaIntermediaria) {
            this.filter.idRegiaoGeograficaIntermediaria = idRegiaoGeograficaIntermediaria;
            this.searchRegioesImediatas();
        } else {
            this.filter.idRegiaoGeograficaIntermediaria = null;
        }

        this.isFilterDirty = true;
    }

    /** Limpa os dados da região geográfica imediata */
    private clearRegiaoImediata() {
        this.filter.idRegiaoGeograficaImediata = null;
        this.regioesImediatas = [];
    }

    /** Pesquisa as regiões geográficas imediatas da região geográfica intermediária selecionada */
    private searchRegioesImediatas() {
        this.regioesImediatas = [];
        const filterRegiaoImediata = new RegiaoGeograficaImediataFilter();
        filterRegiaoImediata.idRegiaoGeograficaIntermediaria = this.filter.idRegiaoGeograficaIntermediaria;
        this.regiaoGeograficaImediataCrudHttpService.searchWithFilter(filterRegiaoImediata)
            .subscribe(
                entities => this.regioesImediatas = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as regiões imediatas para o filtro da cidade', error)
            );
    }
}
